export var GooglePayButtonTypeEnumsObj = {
    BOOK: "book",
    BUY: "buy",
    CHECKOUT: "checkout",
    DONATE: "donate",
    ORDER: "order",
    PAY: "pay",
    PLAIN: "plain",
    SUBSCRIBE: "subscribe",
};
